<template>
  <!-- <connector-detail-v2 :id="id" :con_type="con_type" v-if="got_feature('feature_new_connector_detail')"/>
  <connector-detail-legacy :id="id" :con_type="con_type" v-else/> -->
  <connector-detail-v2 :id="id" :con_type="con_type"/>
</template>

<script>
import { mapGetters } from "vuex";
// import ConnectorDetailLegacy from "@/views/ConnectorDetailLegacy.vue";
import ConnectorDetailV2 from "@/views/ConnectorDetailV2.vue";

export default {
  name: "ConnectorDetail",

  components: {
    // ConnectorDetailLegacy,
    ConnectorDetailV2
  },

  props: {
    id: {
      type: [String, Number],
    },
    con_type: {
      type: String,
    },
  },

  computed: {
    ...mapGetters({
      userData: "me/userData",
      got_feature:'got_feature',
    }),
  },
};
</script>

<style></style>
